export const TOKEN_DB_KEY = 'ZU_CEET@Db_token'
export const USER_AUTH_KEY = 'ZU_CEET@Auth_User'
